import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Stack, Typography, Button } from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';
import { TableV2, CustomFilterV2 } from '../../../components/v2';
import * as selectorsPolos from '../../../store/polo/reducer';
import * as actionsPolos from '../../../store/polo/actions';
import Formulario from './Formulario';

const Polos = ({ polos, loadPolos, deletePolo }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);

  useEffect(() => {
    loadPolos();
  }, [loadPolos]);

  const columns = [
    { field: 'codigo', headerName: 'Código', flex: 0.4 },
    { field: 'nome', headerName: 'Nome', flex: 1 },
    { field: 'gerenciaCodigo', headerName: 'Gerência', flex: 0.5 },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Polos</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          rows={polos}
          columns={columns}
          onEdit={id => { setOpen(true); setId(id); }}
          onDelete={id => deletePolo(id)}
          headerActions={[
            { label: 'Novo', onClick: () => { setOpen(true); setId(null); }, startIcon: <AddIcon />, variant: 'contained' },
          ]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          fields={[
            { field: 'useCodigo', md: 4 },
            { field: 'useMalha', md: 4 },
            { field: 'useGerencia', md: 4 },
          ]}
          onFilter={filterData => {
            loadPolos(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={isSave => {
            setOpen(false);
            setId(null);
            if (isSave) loadPolos();
          }}
          polos={polos}
        />
      </Stack>
    </Box>
  );
};

Polos.propTypes = {
  deletePolo: PropTypes.func.isRequired,
  loadPolos: PropTypes.func.isRequired,
  polos: PropTypes.array,
};

const mapStateToProps = state => ({
  polos: selectorsPolos.getPolos(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsPolos
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Polos));
